import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { AppService } from "../../../../services/app.service";
import { ApiserviceService } from "../../../../httpservice/apiservice.service";
import { HttpClient } from "@angular/common/http";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  ToastController,
  AlertController,
  LoadingController,
  Platform,
  IonInput,
} from "@ionic/angular";
import { Router } from "@angular/router";
import { errMsg } from "../../../../text_control/error-msg";
import { Storage } from "@ionic/storage";
import { ADDRESS } from "../../../../text_control/text_address";
import { BTN } from "../../../../text_control/text_button";
import { ROUTE } from "src/app/constant/routes";
import { _getStorage, _setStorage } from "src/app/utils/local-storage";
import { STORAGE } from "src/app/constant/storages";

export interface Fruit {
  numbers: string;
}

export interface TelEN {
  telENName: string;
}

@Component({
  selector: "app-tax-invoice-savedata",
  templateUrl: "./tax-invoice-savedata.component.html",
  styleUrls: ["./tax-invoice-savedata.component.scss"],
})
export class TaxInvoiceSavedataComponent implements OnInit {
  @ViewChild("input") inputElement: IonInput;
  @ViewChild("inputcompanyname") InputCompanyName;
  @ViewChild("inputtaxid") InputTaxID;
  @ViewChild("inputhouseno") InputHouseNo;
  @ViewChild("inputvillage") InputVillage;
  @ViewChild("inputlane") InputLane;
  @ViewChild("inputload") InputLoad;
  @ViewChild("inputsubdistrict") InputSubDistrict;
  @ViewChild("inputdistrict") InputDistrict;
  @ViewChild("inputprovince") InputProvince;
  @ViewChild("inputpostcode") InputPostCode;
  @ViewChild("inputcard") Inputcard;
  @ViewChild("inputEmail") InputEmail;
  public text_addr: any = {};
  public text_btn: any = {};
  buyer_agree_tmp = "Y";
  buyer_branch_no: any = "";
  buyer_citizen_id = "";
  buyer_company_name = "";
  buyer_fname = "";
  buyer_main_branch_no = "";
  buyer_passpost_id = "";
  buyer_phone = "";
  buyer_sname = "";
  buyer_tax_id: any = "";
  branch_no = "";
  buyer_id = "";
  buyer_people_id = "";
  buyer_status = "";

  seller_id = null;
  room_no = "";
  floor = "";
  building_no = "";
  building_name = "";
  house_no = "";
  village_no = "";
  lane = "";
  road = "";
  sub_district = "";
  district = "";
  province = "";
  postcode = "";
  phone: any = "";
  email = "";
  address_status = "1";
  buyer_type: string;
  selectedDevice = "";

  showbranch1 = false;
  showbranch2 = true;

  showbtn1 = true;
  showbtn2 = false;
  buyer_tax_id1 = "";
  showadd = false;
  showback = true;
  showrefresh = true;
  public searchTerm: string = "";
  template_lang: any = "TH";
  window: any;
  dataphone: any = [];

  dataCountry: any = [];
  country: any = "";
  dataCountrysearch: any = [];

  showTH = false;
  showEN = true;

  addrENCountry = "";
  addrENPostCode = "";
  addrENProvince = "";
  addrEN: String = "";
  addrENOther = "";

  showOther = false;
  redioaddress = "1";

  emailEN = "";
  telEN = "";

  showsaveTH = true;
  showsaveEN = false;
  showaddrTH = false;
  showaddrEN = false;
  showtype1 = false;
  showtype2 = false;

  showcard = true;
  noshowcard = false;
  cardplaceholder = "";
  cardID = true;
  showtoggle = true;
  isCard = "";
  showCompanyName = false;
  showTaxIDType = false;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";

  isAddress = false;
  addressline1 = "";

  constructor(
    public appservice: ApiserviceService,
    public apiservice: ApiserviceService,
    public http: HttpClient,
    public toastController: ToastController,
    public alertController: AlertController,
    public appService: AppService,
    public route: Router,
    public loadingController: LoadingController,
    public platform: Platform,
    public storage: Storage
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);

    this.text_addr = ADDRESS;
    this.text_btn = BTN;
    let v = _getStorage(STORAGE.DATA_CARDID);
    // this.storage.get(STORAGE.DATA_CARDID).then(async (v: any) => {
    this.isCard = v;
    this.settingCard(v);
    // });
    this.appService.cardEvent.subscribe(async (v) => {
      this.isCard = v;
      await this.settingCard(v);
    });
    this.ionViewDidEnter();
  }

  checkProvince(event) {
    let province = this.appService.address_thai.filter(
      (item) => item.province === event.target.value
    );
    if (province.length > 0) {
      setTimeout(() => {
        document.getElementById("inputEmail").focus();
      }, 1000);
    }
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.sub_district = item.district;
    this.district = item.amphoe;
    this.province = item.province;
    this.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.postcode = "";
    }
    if (name === "Province") {
      this.province = "";
    }
    if (name === "District") {
      this.district = "";
    }
    if (name === "SubDistrict") {
      this.sub_district = "";
    }
  }

  async settingCard(v) {
    this.isAddress = false;
    if (v === "0") {
      if (this.iSchecktype.buyer_type !== undefined) {
        this.cardID = false;
        this.showcard = false;
        this.noshowcard = true;
        this.showperson1 = false;
        this.showperson3 = false;
        this.showperson2 = true;
        this.showfont = false;
        this.showname = false;
        this.branch = false;
        // this.buyer_main_branch_no = "00000";
        this.buyer_tax_id1 = "";
        this.buyer_type = this.iSchecktype.buyer_type;
        if (this.buyer_type === "0" || this.buyer_type === "2") {
          this.branch = false;
          this.showtype1 = false;
        } else {
          this.showTaxIDType = true;
          this.showCompanyName = true;
          this.showtype1 = true;
          this.buyer_branch_no = String(this.iSchecktype.buyer_branch_no);
          this.branch = true;
          if (this.buyer_branch_no !== "") {
            this.buyer_main_branch_no = "11111";
            this.showbranch2 = false;
          } else {
            this.buyer_main_branch_no = this.iSchecktype.buyer_main_branch_no;
            this.buyer_branch_no = "";
          }
        }
      } else {
        this.showCompanyName = false;
        this.buyer_type = "";
        this.showtype1 = false;
        this.cardID = false;
        this.showcard = false;
        this.noshowcard = true;
        this.showperson1 = false;
        this.showperson3 = false;
        this.showperson2 = false;
        this.showfont = false;
        this.showname = false;
        this.branch = false;
        this.buyer_main_branch_no = "";
        this.buyer_tax_id1 = "";
        this.cardplaceholder = "";
      }
    }
    if (v === "1") {
      if (this.iSchecktype.buyer_type !== undefined) {
        this.showperson1 = false;
        this.showperson3 = false;
        this.showperson2 = true;
        this.showfont = false;
        this.showname = false;
        this.branch = false;
        // this.buyer_main_branch_no = "00000";
        this.buyer_tax_id1 = "";
        this.noshowcard = false;
        this.showcard = true;
        this.cardID = true;
        this.province = this.Addrress.province ? this.Addrress.province : "";
        this.district = this.Addrress.district ? this.Addrress.district : "";
        this.sub_district = this.Addrress.sub_district
          ? this.Addrress.sub_district
          : "";
        this.buyer_type = this.iSchecktype.buyer_type;
        if (this.buyer_type === "0" || this.buyer_type === "2") {
          this.branch = false;
          this.showtype1 = false;
        } else {
          this.showTaxIDType = true;
          this.showCompanyName = true;
          this.showtype1 = true;
          this.buyer_branch_no = String(this.iSchecktype.buyer_branch_no);
          this.branch = true;
          if (this.buyer_branch_no !== "") {
            this.buyer_main_branch_no = "11111";
            this.showbranch2 = false;
          } else {
            this.buyer_main_branch_no = this.iSchecktype.buyer_main_branch_no;
            this.buyer_branch_no = "";
          }
        }
      } else {
        this.buyer_type = "0";
        this.showtype1 = false;
        this.showperson1 = true;
        this.showperson3 = false;
        this.showperson2 = false;
        this.showfont = false;
        this.showname = true;
        this.branch = false;
        // this.buyer_main_branch_no = "00000";
        this.buyer_tax_id1 = "";
        this.noshowcard = false;
        this.showcard = true;
        this.cardID = true;
        this.showTaxIDType = true;
        this.showCompanyName = true;

        this.province = this.Addrress.province ? this.Addrress.province : "";
        this.district = this.Addrress.district ? this.Addrress.district : "";
        this.sub_district = this.Addrress.sub_district
          ? this.Addrress.sub_district
          : "";
      }
      setTimeout(async () => {
        document.getElementById("inputcompanyname").focus();
        this.cardplaceholder = "จุดเริ่มต้นเครื่องอ่านบัตร";
      }, 1);
    }
  }

  ngOnInit() {
    this.addressManual = false;
    this.groupAddress = this.appService.address_thai;
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });
  }
  checkaddressTH() {
    this.template_lang = "TH";
    this.showsaveTH = true;
    this.showsaveEN = false;
    this.showTH = false;
    this.showEN = true;
  }
  checkaddressEN() {
    this.template_lang = "EN";
    this.showsaveTH = false;
    this.showsaveEN = true;
    this.showTH = true;
    this.showEN = false;
  }

  checkaddrENOther() {
    this.showOther = this.addrENCountry !== "Other" ? false : true;
  }

  checkPostcodeEN(e) {
    this.addrENPostCode = e.target.value.match(/[0-9]*/)[0];
  }

  focusInput() {
    this.addrENCountry = Object(this.addrENOther);
  }
  searchaddrEN(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.dataCountry = this.dataCountrysearch.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }

    if (val === "") {
      this.reloadcountry();
    }
  }

  reloadcountry() {
    this.dataCountry = this.appService.Country;
    this.dataCountrysearch = this.appService.Country;
  }

  async refresh() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please refresh...",
    });
    await loading.present();
    window.location.reload();
  }

  showperson1 = false;
  showperson2 = false;
  showperson3 = false;
  showperson = true;
  showfont = true;
  showname = false;
  showname1 = false;
  branch = true;
  checktype(e, n) {
    if (n === 1) {
      if (this.isCard === "0") {
        this.showCompanyName = true;
        this.showTaxIDType = true;
        this.cardID = false;
        this.showcard = false;
        this.noshowcard = true;
        this.showperson1 = true;
        this.showperson3 = false;
        this.showperson2 = false;
        this.showfont = false;
        this.showname = true;
        this.branch = false;
        this.buyer_branch_no = "";
        this.buyer_main_branch_no = "00000";
        this.buyer_tax_id1 = "";
      }
      if (this.isCard === "1") {
        this.showCompanyName = true;
        this.showTaxIDType = true;
        this.showperson1 = true;
        this.showperson3 = false;
        this.showperson2 = false;
        this.showfont = false;
        this.showname = true;
        this.branch = false;
        this.buyer_branch_no = "";
        this.buyer_main_branch_no = "00000";
        this.buyer_tax_id1 = "";
        this.noshowcard = false;
        this.showcard = true;
        this.province = "";
        this.district = "";
        this.sub_district = "";
        this.cardID = true;
        setTimeout(() => {
          document.getElementById("inputcompanyname").focus();
          this.cardplaceholder = "จุดเริ่มต้นเครื่องอ่านบัตร";
        }, 1);
      }
    }
    if (n === 2) {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.showperson1 = false;
      this.showperson2 = true;
      this.showperson3 = false;
      this.showname1 = true;
      this.showfont = false;
      this.showname = false;
      this.branch = true;
      this.cardID = false;
      this.showcard = false;
      this.noshowcard = true;
      this.showtoggle = false;
      this.buyer_branch_no = "";
      this.buyer_main_branch_no = "00000";
      this.buyer_tax_id1 = "";
      this.cardplaceholder = "";
    }
    if (n === 3) {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.showperson1 = false;
      this.showperson2 = false;
      this.showperson3 = true;
      this.showfont = false;
      this.showname = true;
      this.branch = false;
      this.showcard = false;
      this.noshowcard = true;
      this.showtoggle = false;
      this.buyer_branch_no = "";
      this.buyer_main_branch_no = "00000";
      this.buyer_tax_id1 = this.buyer_tax_id;
      this.cardplaceholder = "";
    }
  }
  checkbranch1() {
    this.showbranch2 = true;
    this.buyer_branch_no = "";
  }
  checkbranch2() {
    this.showbranch2 = false;
    this.buyer_main_branch_no = "";
  }

  checkinput1(e) {
    this.buyer_tax_id = e.target.value.match(/[0-9]*/)[0];
  }
  checkTaxID1(e) {
    this.buyer_tax_id1 = e.target.value.match(/[0-9a-zA-Z]*/)[0];
  }
  creditcard_num: any;
  checkbranch(e) {
    this.buyer_branch_no = e.target.value.match(/[0-9]*/)[0];
  }
  checkpostcode(e) {
    this.postcode = e.target.value.match(/[0-9]*/)[0];
  }

  datasave: any = [];
  async confirmBuyer(addr_type: string) {

  
    let phones = [];
    for (let i of this.fruits) {
      phones.push(i.numbers);
    }

    let addr = {
      sub_district:
        this.showcard === true
          ? this.checkUndefined(this.sub_district)
          : this.checkUndefined(this.sub_district),
      province:
        this.showcard === true
          ? this.checkUndefined(this.province)
          : this.checkUndefined(this.province),
      district:
        this.showcard === true
          ? this.checkUndefined(this.district)
          : this.checkUndefined(this.district),
      phones: phones,
    };

    let validate: string = this.validateRequest(addr_type, addr);

    if (validate !== "") {
      return await this.ErrorMsg(validate);
    }

    let reqBody = this.getRequestBodyData(addr_type, addr);

    console.log("[confirmBuyer] reqBody : ", reqBody);

    let url = this.apiservice.apiUrl + this.apiservice.updateCustomer;

    try {
      this.appservice._post(url, reqBody).then(async (res: any) => {
        this.datasave = res.data;
        console.log("[confirmBuyer] response : ", res);
        if (res.statusCode === 200) {
          for (let i = 0; i < this.datasave.length; i++) {
            if (this.datasave[i].buyer_branch_no != "")
              this.buyer_main_branch_no = "11111";
          }
          const alert = await this.alertController.create({
            cssClass: "my-custom-class",
            message: "บันทึกข้อมูลเรียบร้อย",
            buttons: [
              {
                text: "OK",
                cssClass: "alertButton",
                handler: (blah) => {
                  this.showbtn2 = true;
                  this.showbtn1 = false;
                  this.showadd = true;
                  this.showTH = true;
                  this.showEN = true;
                  this.showsaveEN = false;
                  this.showsaveTH = false;
                  this.showbranch2 = true;
                  this.showaddrTH = true;
                  this.showaddrEN = true;
                  this.showtype1 = true;
                  this.showback = false;
                  this.showrefresh = false;
                },
              },
            ],
          });
          await alert.present();
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      });
    } catch (error) {
      this.ErrorMsg(errMsg.error);
    }
    

 


  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  checkAddress(e) {
    console.log("checkAddress event =======:: ", e);
    this.isAddress = e.detail.checked;
  }

  checkUndefined(data: string) {
    if (!data || data === undefined) return "";
    return data;
  }

  validateRequest(addr_type: string, addr: any): string {
    //buyer information
    if (this.buyer_type == "") return errMsg.buyer_type;
    if (this.buyer_company_name == "") return errMsg.buyer_company_name;
    if (this.buyer_type !== "2" && this.buyer_type !== "3" && this.buyer_tax_id == "")
      return errMsg.buyer_tax_id;
    if (
      this.buyer_type !== "2" && this.buyer_type !== "3" &&
      !this.appService.checkIdentityCardNumber(this.buyer_tax_id)
    )
      return errMsg.card_tax;
    if (this.buyer_type == "2" && this.buyer_tax_id1.trim() == "")
      return errMsg.buyer_tax_id;
    if (this.buyer_main_branch_no === "11111" && this.buyer_branch_no === "")
      return errMsg.buyer_main_branch_no;

      if (this.buyer_type == "2" && this.buyer_tax_id1.trim() == "")
      return errMsg.buyer_tax_id1;
    if (this.buyer_main_branch_no === "11111" && this.buyer_branch_no === "")
      return errMsg.buyer_main_branch_no;

    if (this.isAddress === true && this.addressline1 === "")
      return errMsg.errorAddressline1;

    if (this.isAddress === true && this.postcode === "") {
      return errMsg.notpostcode;
    }
  if (this.isAddress === true && this.postcode.length < 5 ) {
      return errMsg.notpostcode;
    }
    let email = "";

 
    // address
    if (this.isAddress === false) {
      if (addr_type === "1") {
      
        let filterPostcode = this.groupAddress.filter(
          (f) => f.zipcode === Number(this.postcode)
        );
        let filterProvince = this.groupAddress.filter(
          (f) => f.province === this.province
        );
        if (this.house_no == "") return errMsg.house_no;
        if (this.postcode == "") return errMsg.postcode;
        if (this.postcode !== "" && filterPostcode.length === 0) {
          return errMsg.notpostcode;
        }
        if (addr.sub_district == undefined || addr.sub_district == "")
          return errMsg.sub_district;
        if (addr.district == undefined || addr.district == "")
          return errMsg.district;
        if (addr.province == undefined || addr.province == "")
          return errMsg.province;
        if (addr.province !== "" && filterProvince.length === 0) {
          return errMsg.notprovince;
        }
        email = this.email;
      } else {
        if (this.addrENProvince == "") return errMsg.addrENProvince;
        if (this.addrENPostCode == "") return errMsg.addrENPostCode;
        if (this.addrENCountry == "") return errMsg.addrENCountry;
        email = this.emailEN;
      }
    }

    if (email != "") {
      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(email)) return "รูปแบบ email ไม่ถูกต้อง";
    }
    return "";
  }

  getRequestBodyData(addr_type: string, addr_detail: any) {
    let result = {
      newCustomerData: {
        buyer_type: this.buyer_type,
        buyer_company_name: this.buyer_company_name,
        buyer_people_id: "",
        buyer_main_branch_no:
          this.buyer_branch_no !== "" ? "" : this.buyer_main_branch_no,
        buyer_branch_no:
          this.buyer_branch_no === ""
            ? ""
            : this.buyer_branch_no.padStart(5, "0"),
        buyer_citizen_id: this.buyer_citizen_id,
        buyer_tax_id:
          this.buyer_type == "2" ? this.buyer_tax_id1 : this.buyer_tax_id,
        buyer_passpost_id: this.buyer_passpost_id,
        buyer_agree_tmp: this.buyer_agree_tmp, // ===>>> key tmp [ ยินยอม Y / ไม่ยินยอม N]
        user_id: this.userID,
        template_lang: this.template_lang,
        buyer_status: "active",
        address_detail: {
          type_addr: addr_type,
          building_no: this.building_no,
          building_name: this.building_name,
          house_no: this.house_no,
          village_no: this.village_no,
          room_no: this.room_no,
          floor: this.floor,
          lane: this.lane,
          road: this.road,
          sub_district: addr_detail.sub_district,
          district: addr_detail.district,
          province: addr_detail.province,
          postcode: String(this.postcode),
          phone: addr_detail.phones.join(","),
          fax: "",
          email: addr_type == "1" ? this.email : this.emailEN,
          address_status: "active",
          addr_agree_tmp: this.buyer_agree_tmp,
          inter_province: this.addrENProvince,
          inter_postcode: this.addrENPostCode,
          inter_country: this.addrENCountry,
          inter_tel: this.telEN,
          inter_address_line1: this.addrEN,
          inter_fax: "",
          seller_id: "",
          buyer_id: "",
          user_id: this.userID,
          is_addresstxt: this.isAddress,
          addressline1: this.addressline1 || "",
        },
      },
    };

    return result;
  }

  checkphone(e) {
    this.phone = e.target.value.match(/[0-9]*/)[0];
  }
  checkphoneEN(e) {
    this.telEN = e.target.value.match(/[0-9]*/)[0];
  }
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[] = [];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.fruits.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  gototaxinvoicesearchbuy() {
    this.appService.setActive(3);
    _setStorage(STORAGE.DATA_ABB, this.datasave[0]);
    _setStorage(STORAGE.DATA_SELECTTAXINVOICE, this.datasave);
    this.route.navigate([ROUTE.TAXINVOICE_SEARCH_ABB]);
  }

  backselecttaxinvoice() {
    this.route.navigate([ROUTE.TAXINVOICE_SELECT]);
  }
  Addrress: any;
  iSchecktype: any;
  ionViewDidEnter() {
    this.appService.setActive(2);
    let v = _getStorage(STORAGE.DATA_CARDID);
    // this.storage.get(STORAGE.DATA_CARDID).then(async (v: any) => {
    this.isCard = v;
    this.settingCard(v);
    // });
    var showprovince = document.getElementById("showSelectProvince");
    var notshowprovince = document.getElementById("notshowselectProvince");

    if (showprovince !== null) {
      showprovince.style.display = "none";
      notshowprovince.style.display = "none";
    }
    this.reloadcountry();
    this.addrENPostCode = "";
    this.addrENProvince = "";
    this.addrEN = "";
    this.emailEN = "";
    this.telEN = "";
    this.buyer_agree_tmp = "Y";
    this.buyer_branch_no = "";
    this.buyer_passpost_id = "";
    this.branch_no = "";
    this.fruits = [];
    this.seller_id = null;
    this.address_status = "1";
    this.selectedDevice = "";
    this.showbranch1 = false;
    this.showbranch2 = true;
    this.showbtn1 = true;
    this.showbtn2 = false;
    this.buyer_tax_id1 = "";
    this.showadd = false;
    this.template_lang = "TH";

    let itemadd: any;
    let addr: any = {};
    itemadd = _getStorage(STORAGE.DATA_CREATEFULLTAX);
    let itemEN: any = itemadd.address_detail[0];
    this.buyer_company_name = itemadd.buyer_company_name;
    this.buyer_tax_id = itemadd.buyer_tax_id.match(/[0-9]*/)[0];
    this.buyer_agree_tmp = itemadd.buyer_agree_tmp;
    this.iSchecktype = itemadd;
    addr = itemadd.address_detail[0];
    if (itemEN.type_addr === "1") {
      this.redioaddress = "1";
    } else if (itemEN.type_addr === "2") {
      this.redioaddress = "2";
    }
    this.buyer_citizen_id = itemadd.buyer_citizen_id
      ? itemadd.buyer_citizen_id
      : "";
    this.buyer_id = itemadd.buyer_id;
    this.buyer_people_id = itemadd.buyer_people_id;
    this.buyer_status = itemadd.buyer_status;
    this.buyer_passpost_id = itemadd.buyer_passpost_id
      ? itemadd.buyer_passpost_id
      : "";
    this.buyer_tax_id = itemadd.buyer_tax_id.match(/[0-9]*/)[0];
    this.template_lang = itemadd.template_lang;
    this.address_status = addr.address_status;
    this.building_name = addr.building_name ? addr.building_name : "";
    this.building_no = addr.building_no ? addr.building_no : "";
    this.email = addr.email ? addr.email : "";
    this.house_no = addr.house_no ? addr.house_no : "";
    this.lane = addr.lane ? addr.lane : "";
    this.road = addr.road ? addr.road : "";
    this.seller_id = addr.seller_id ? addr.seller_id : "";
    this.village_no = addr.village_no ? addr.village_no : "";
    this.floor = addr.floor ? addr.floor : "";
    this.room_no = addr.room_no ? addr.room_no : "";
    this.sub_district = addr.sub_district ? addr.sub_district : "";
    this.district = addr.district ? addr.district : "";
    this.province = addr.province ? addr.province : "";
    this.postcode = addr.postcode ? addr.postcode : "";
    this.addressline1 = addr.addressline1 ? addr.addressline1 : "";
    this.isAddress = addr.is_addresstxt ? addr.is_addresstxt : "";

    //==========Start Address EN===================//

    this.addrENCountry = itemEN.inter_country ? itemEN.inter_country : "";
    this.addrENPostCode = itemEN.inter_postcode ? itemEN.inter_postcode : "";
    this.addrENProvince = itemEN.inter_province ? itemEN.inter_province : "";
    this.addrEN = itemEN.inter_address_line1 ? itemEN.inter_address_line1 : "";
    this.emailEN = itemEN.email ? itemEN.email : "";
    this.telEN = itemEN.inter_tel ? itemEN.inter_tel : "";

    //===========End Address EN===================//

    this.Addrress = itemadd.address_detail[0];
    this.dataphone = itemadd.address_detail[0].phone.split(",");
    if (this.dataphone[0] === "") {
      this.dataphone = "";
    }
    for (let i of this.dataphone) {
      this.fruits.push({
        numbers: i,
      });
    }
  }

  checkemail(e) {
    this.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  checkemailEN(e) {
    this.emailEN = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }

numberOnly(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}
}
